import { render, staticRenderFns } from "./Card-list.vue?vue&type=template&id=c0195918&"
import script from "./Card-list.vue?vue&type=script&lang=js&"
export * from "./Card-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports